import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

interface DetailPageSkeletonProps {
  showFlowbar?: boolean;
  tabCount?: number;
  /** Real controls for the right end of the tab row, shown while the rest loads. */
  tabActions?: React.ReactNode;
}

export const DetailPageSkeleton: React.FC<DetailPageSkeletonProps> = ({
  showFlowbar = true,
  tabCount = 5,
  tabActions,
}) => (
  <div>
    <div className="mb-6 flex items-center">
      <Skeleton className="mr-4 h-10 w-10 rounded-md" />
      <div className="min-w-0 flex-1">
        <Skeleton className="mb-1 h-9 max-w-md" style={{ width: "60%" }} />
        <Skeleton className="h-5 max-w-xs" style={{ width: "40%" }} />
      </div>
    </div>

    {showFlowbar && (
      <div className="mb-6">
        <Skeleton className="h-12 w-full rounded-md" />
      </div>
    )}

    <Card className="mb-6">
      {tabCount > 0 && (
        <div className="flex flex-wrap gap-2 border-b px-2 pt-2">
          {Array.from({ length: tabCount }).map((_, i) => (
            <Skeleton key={i} className="mb-2 h-9 w-24" />
          ))}
          {tabActions && <div className="ml-auto pb-2">{tabActions}</div>}
        </div>
      )}
      <CardContent className="space-y-4 p-6">
        <Skeleton className="h-[120px] w-full rounded-md" />
        <Skeleton className="h-[120px] w-full rounded-md" />
        <Skeleton className="h-20 w-full rounded-md" />
      </CardContent>
    </Card>
  </div>
);

export default DetailPageSkeleton;
